import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { PrintQueueRepoImpl } from "domain/repository/Common/PrintQueueRepoImpl";
import { RemoteFileInfoRepoImpl } from "domain/repository/Common/RemoteFileInfoRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CustomerRepoImpl } from "domain/repository/Company/CustomerRepoImpl";
import { CriteriaTypeRepoImpl } from "domain/repository/Criteria/CriteriaTypeRepoImpl";
import { GeneralReportRepoImpl } from "domain/repository/GeneralReport/GeneralReportRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { OpsLineRepoImpl } from "domain/repository/OpsLine/OpsLineRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { StandardProposalRepoImpl } from "domain/repository/StandardProposal/StandardProposalRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { UserRepoImpl } from "domain/repository/User/UserRepoImpl";
import { useGeneralReportTracked } from "presentation/store/GeneralReport/GeneralReportProvider";
import { GeneralReportVM } from "presentation/viewModel/GeneralReport/GeneralReportVM";
import { useMemo } from "react";

export const useGeneralReportVM = () => {
    const [, setGeneralReportState] = useGeneralReportTracked();
    const generalReportVM = useMemo(() =>
        GeneralReportVM({
            dispatch: [setGeneralReportState],
            generalReportRepo: GeneralReportRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            printQueueRepo: PrintQueueRepoImpl(),
            remoteFileInfoRepo: RemoteFileInfoRepoImpl(),
            customerRepo: CustomerRepoImpl(),
            criteriaTypeRepo: CriteriaTypeRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            tariffTypeRepo: TariffTypeRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
            standardProposalRepo: StandardProposalRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            opsLineRepo: OpsLineRepoImpl(),
            userRepo: UserRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
        }), [setGeneralReportState])

    return generalReportVM
}